import styled from "styled-components";

export const Styles = styled.span`
  .label-summary {
    white-space: nowrap;
  }
  .value-summary {
    color: var(--text-color-summary);
    font-weight: 700;
    margin-left: 8px;
  }
`;
